/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ControlNodeTypeEnum {
}

export enum ControlNodeTypeEnum_Enum {
  UNSPECIFIED = 0,
  /** RUN_ALL - Run all actions */
  RUN_ALL = 1,
  /** RUN_UNTIL_FAILURE - Run actions until one fails */
  RUN_UNTIL_FAILURE = 2,
  /** RUN_UNTIL_SUCCESS - Run actions until one succeeds */
  RUN_UNTIL_SUCCESS = 3,
  UNRECOGNIZED = -1,
}

export function controlNodeTypeEnum_EnumFromJSON(object: any): ControlNodeTypeEnum_Enum {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return ControlNodeTypeEnum_Enum.UNSPECIFIED;
    case 1:
    case "RUN_ALL":
      return ControlNodeTypeEnum_Enum.RUN_ALL;
    case 2:
    case "RUN_UNTIL_FAILURE":
      return ControlNodeTypeEnum_Enum.RUN_UNTIL_FAILURE;
    case 3:
    case "RUN_UNTIL_SUCCESS":
      return ControlNodeTypeEnum_Enum.RUN_UNTIL_SUCCESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ControlNodeTypeEnum_Enum.UNRECOGNIZED;
  }
}

export function controlNodeTypeEnum_EnumToJSON(object: ControlNodeTypeEnum_Enum): string {
  switch (object) {
    case ControlNodeTypeEnum_Enum.UNSPECIFIED:
      return "UNSPECIFIED";
    case ControlNodeTypeEnum_Enum.RUN_ALL:
      return "RUN_ALL";
    case ControlNodeTypeEnum_Enum.RUN_UNTIL_FAILURE:
      return "RUN_UNTIL_FAILURE";
    case ControlNodeTypeEnum_Enum.RUN_UNTIL_SUCCESS:
      return "RUN_UNTIL_SUCCESS";
    case ControlNodeTypeEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LooperResultData {
}

export interface LooperActionStateData {
}

function createBaseControlNodeTypeEnum(): ControlNodeTypeEnum {
  return {};
}

export const ControlNodeTypeEnum = {
  encode(_: ControlNodeTypeEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ControlNodeTypeEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlNodeTypeEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ControlNodeTypeEnum {
    return {};
  },

  toJSON(_: ControlNodeTypeEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlNodeTypeEnum>, I>>(base?: I): ControlNodeTypeEnum {
    return ControlNodeTypeEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlNodeTypeEnum>, I>>(_: I): ControlNodeTypeEnum {
    const message = createBaseControlNodeTypeEnum();
    return message;
  },
};

function createBaseLooperResultData(): LooperResultData {
  return {};
}

export const LooperResultData = {
  encode(_: LooperResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LooperResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLooperResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LooperResultData {
    return {};
  },

  toJSON(_: LooperResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LooperResultData>, I>>(base?: I): LooperResultData {
    return LooperResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LooperResultData>, I>>(_: I): LooperResultData {
    const message = createBaseLooperResultData();
    return message;
  },
};

function createBaseLooperActionStateData(): LooperActionStateData {
  return {};
}

export const LooperActionStateData = {
  encode(_: LooperActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LooperActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLooperActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LooperActionStateData {
    return {};
  },

  toJSON(_: LooperActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LooperActionStateData>, I>>(base?: I): LooperActionStateData {
    return LooperActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LooperActionStateData>, I>>(_: I): LooperActionStateData {
    const message = createBaseLooperActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
